/**
 * Signup notification hook.
 * External n8n/webhook delivery was retired with unused integrations.
 * Keep a local no-op so invite signup still completes.
 */

import logger from './logger';

export const notifyNewUserSignup = async (user, method, profileData = {}) => {
  logger.info('Signup completed; external webhook delivery is retired.', {
    uid: user?.uid || null,
    method,
    company: profileData?.company || null
  });
  return { skipped: true, reason: 'external-webhook-retired' };
};

export default {
  notifyNewUserSignup
};
